const potensiKampungList = (state) => {
  return state.potensiKampungs.data;
};

export default {
  potensiKampungList,
};
